import React from "react";

export default function Logo({ className = "", showText = true, dark = false }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <svg width="34" height="34" viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <defs>
          <linearGradient id="lx" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
            <stop stopColor="#22D3EE" />
            <stop offset="0.5" stopColor="#0891B2" />
            <stop offset="1" stopColor="#0369A1" />
          </linearGradient>
        </defs>
        {/* faint light cone from the optical sensor */}
        <path d="M24 9 L15 29 L33 29 Z" fill="url(#lx)" opacity="0.12" />
        {/* water droplet */}
        <path d="M24 16c0 0 8.5 9 8.5 14.5a8.5 8.5 0 0 1-17 0C15.5 25 24 16 24 16Z" fill="url(#lx)" />
        {/* subtle nexus ring inside droplet */}
        <circle cx="24" cy="30.5" r="3" fill="none" stroke="#ffffff" strokeOpacity="0.5" strokeWidth="1.3" />
        {/* optical lens / sensor */}
        <circle cx="24" cy="8" r="4.2" fill="url(#lx)" />
        <circle cx="24" cy="8" r="1.7" fill="#ffffff" />
      </svg>
      {showText && (
        <span className={`font-display font-extrabold tracking-tight text-[1.15rem] leading-none ${dark ? "text-white" : "text-slate-900"}`}>
          Aqualux<span className="aqua-text"> Nexus</span>
        </span>
      )}
    </div>
  );
}
